import "./DealJourneyNavigator.css";

import { useContext } from "react";

import { CompletedCircleGreenIcon, InProgressCircleGreenIcon, NotStartedCircleGreyIcon } from "../../../../../assets";
import { DealJourneyNavigatorPages } from "../../../../../constants";
import { Button } from "../../../../../widget";
import { NewDealJourneyContext } from "../../NewDealJourneyContext";

export const DealJourneyNavigator = (): JSX.Element => {
  const { currentPage, inProgressPage, handlePageChange } = useContext(NewDealJourneyContext);

  const pages = Object.values(DealJourneyNavigatorPages);
  const inProgressPageIndex = pages.indexOf(inProgressPage);

  return (
    <div className="DealJourneyNavigatorContainer">
      {pages.map((page, index) => (
        <div key={page} className="DealJourneyNavigatorItem">
          {(index < inProgressPageIndex && <CompletedCircleGreenIcon />) ||
            (index === inProgressPageIndex && <InProgressCircleGreenIcon />) ||
            (index > inProgressPageIndex && <NotStartedCircleGreyIcon />)}
          <div className="Label">
            {page === currentPage ? (
              <span className="body2">{page}</span>
            ) : (
              <Button
                text={page}
                variant="quinary"
                textUnderline
                hasNoPadding
                minWidth={false}
                size="small"
                onClick={() => handlePageChange(page)}
              />
            )}
          </div>
          {index < pages.length - 1 && <div className={`Divider ${index < inProgressPageIndex && "Complete"}`} />}
        </div>
      ))}
    </div>
  );
};
